import React from "react";
import { Grid } from "@mui/material";
import { ConfigSection } from "../ConfigSection";
import { StyledTextField } from "../StyledTextField";
import { validateSlop, validateMaxExpansions } from "../../utils/validation";
import { MatchPhrasePrefixConfigSectionProps } from "../../types";

export const MatchPhrasePrefixConfigSection: React.FC<
  MatchPhrasePrefixConfigSectionProps
> = ({ config, updateMatchPhrasePrefixConfig }) => (
  <ConfigSection
    title="Match Phrase Prefix Configuration"
    tooltip="This is similar to phrase matching, but it also works with incomplete words. For example, if you search for 'red app', it can find 'red apple' even though you didn't finish typing 'apple'. You can control how flexible this matching is and how many possible word completions it should consider."
  >
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <StyledTextField
          fullWidth
          label="Slop"
          type="number"
          inputProps={{ min: 0, max: 100 }}
          value={config.matchPhrasePrefixConfig?.slop ?? ""}
          validate={validateSlop}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const value = e.target.value;
            updateMatchPhrasePrefixConfig({
              slop: value === "" ? undefined : parseInt(value),
            });
          }}
          helperText="How strict phrase matching is with partial last words. Range: 0–100."
        />
      </Grid>
      <Grid item xs={6}>
        <StyledTextField
          fullWidth
          label="Max Expansions"
          type="number"
          inputProps={{ min: 1, max: 1000 }}
          value={config.matchPhrasePrefixConfig?.maxExpansions ?? ""}
          validate={validateMaxExpansions}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const value = e.target.value;
            updateMatchPhrasePrefixConfig({
              maxExpansions: value === "" ? undefined : parseInt(value),
            });
          }}
          helperText="Maximum prefix completions to consider. Range: 1–1,000."
        />
      </Grid>
    </Grid>
  </ConfigSection>
);
